<template>
    <gofix-card :title="titleCard">
        <template slot="gofixCard:right_header">
            <div class="d-flex justify-content-end align-items-center">
                <gofix-button label="Save" @click="save" :loading="loading"></gofix-button>
            </div>
        </template>
        <b-row>
            <b-col md="4">
                <gofix-form-input label="Name" v-model="property.name"></gofix-form-input>
            </b-col>
            <template v-if="!isRoot">
                <b-col md="4">
                    <gofix-form-properties
                        label="Parent"
                        :contract-id="$route.params.id"
                        :valueFormat="'object'"
                        search-nested
                        v-model="objTemp.parent"
                        required
                        :disabled="property.id && property.type == 'Location'"
                        ref="parent-property">
                    </gofix-form-properties>
                </b-col>
                <b-col md="4">
                    <b-row>
                        <b-col md="8">
                            <gofix-text-field label="Address" class="addressCustom" oneline valueSmall>
                                <template slot="gofixTextField:before_label">
                                    <gofix-button label="Edit" @click="editAddress" noBorder fontNormal small></gofix-button>
                                </template>
                                <template slot="gofixTextField:after">
                                    <p class="pt-5 mb-0">{{ displayData.full_address }}</p>
                                </template>
                            </gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <b-form-checkbox v-model="property.is_active" class="mt-25 ml-16"><span class="ml-2">Active</span></b-form-checkbox>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="2">
                    <gofix-form-dropdown
                        class="gofixInputNoMinWidth"
                        label="Node Type"
                        vLabel="text"
                        :reduce="option => option.value"
                        :selectable="option => !option.disabled"
                        v-model="property.type"
                        :options="nodeTypes">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="2">
                    <gofix-form-dropdown
                        label="Property type"
                        vLabel="reference_value_text"
                        :reduce="option => option.reference_value_text"
                        v-model="property.property_type_text"
                        :options="propertyTypes">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="2">
                    <gofix-form-dropdown
                        label="Location type"
                        vLabel="reference_value_text"
                        :reduce="option => option.reference_value_text"
                        v-model="property.location_type_text"
                        :options="locationTypes">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="2">
                    <div class="custom-checkbox-modal mt-30">
                        <b-form-checkbox-group id="checkbox-group-2" disabled v-model="property.lettable">
                            <b-form-checkbox class="label-pl-short" value="true">Lettable</b-form-checkbox>
                        </b-form-checkbox-group>
                    </div>
                </b-col>
                <b-col md="4">
                    <gofix-form-dropdown
                        label="Category"
                        vLabel="reference_value_text"
                        :reduce="option => option.reference_value_text"
                        v-model="property.category_text"
                        :options="categories">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="4">
                    <gofix-form-input-number
                        class="gofixTextInput_lowercase"
                        label="GFA [sq ft]"
                        v-model="property.gfa"
                        desc=" ">
                    </gofix-form-input-number>
                </b-col>
                <b-col md="4">
                    <gofix-form-input-number
                        class="gofixTextInput_lowercase"
                        label="NLA [sq ft]"
                        v-model="property.nla"
                        desc=" ">
                    </gofix-form-input-number>
                </b-col>
                <b-col md="4">
                    <gofix-form-input label="Owner" v-model="property.owner"></gofix-form-input>
                </b-col>
                <b-col md="3">
                    <gofix-form-input-number
                        label="Min Rent [$]"
                        v-model="property.mininum_rent"
                        prefix="$">
                    </gofix-form-input-number>
                </b-col>
                <b-col md="3">
                    <gofix-form-input-number
                        class="gofixTextInput_lowercase"
                        label="Min Rate [$ psft]"
                        v-model="property.minimum_rate_psf"
                        prefix="$">
                    </gofix-form-input-number>
                </b-col>
                <b-col md="3">
                    <gofix-form-input-number
                        label="Reference Rent [$]"
                        v-model="property.reference_rent"
                        prefix="$">
                    </gofix-form-input-number>
                </b-col>
                <b-col md="3">
                    <gofix-form-input-number
                        class="gofixTextInput_lowercase"
                        label="Reference Rate [$ psft]"
                        v-model="property.reference_rate_psf"
                        prefix="$">
                    </gofix-form-input-number>
                </b-col>
            </template>
        </b-row>
        <b-row align-v="center" v-if="!isRoot">
            <b-col md="3">
                <gofix-form-input label="Configured As" disabled v-model="property.configured_as"></gofix-form-input>
            </b-col>
            <b-col md="3">
                <gofix-form-input-date
                    label="Effective Date"
                    disabled
                    popoverDirection="top"
                    :min-date="minDate"
                    v-model="property.effective_date" >
                </gofix-form-input-date>
            </b-col>
            <b-col md="3">
                <gofix-button label="Edit" :disabled="!property || !property.id" @click="showConfiguredAs" noBorder fontNormal small></gofix-button>
            </b-col>
        </b-row>
        <b-modal
            id="modal-Address"
            title="Address"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            v-model="open"
            ref="modal-address">
            <b-form class="pb-10">
                <gofix-form-input label="Street Number" v-model="address.street_no"></gofix-form-input>
                <gofix-form-input label="Street Name" v-model="address.street_name"></gofix-form-input>
                <gofix-form-input label="Unit no" v-model="address.unit_no"></gofix-form-input>
                <gofix-form-input label="Building Name" v-model="address.building_name"></gofix-form-input>
                <gofix-form-input label="Country" v-model="address.country" disabled></gofix-form-input>
                <gofix-form-input label="Postal Code" v-model="address.postal_code"></gofix-form-input>
                <gofix-form-input label="Latitude" v-model="address.geo_location.latitude"></gofix-form-input>
                <gofix-form-input label="Longitude" v-model="address.geo_location.longtitude"></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="hanldeAddress" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <PropertyModalConfigField
            v-model="modal.open"
            :property_id="modal.property_id"
            @storeDataSuccess="refreshProperty"
        />
    </gofix-card>
</template>
<script>
import { generalAddressFormat } from "./../../../_commonVar.js";
const PropertyModalConfigField = () => import("./property-modal-config-field")
import moment from 'moment';
const cstNodeTypes = [
    {
        value: 'Cluster',
        text: 'Cluster',
        disabled: false
    },
    {
        value: 'Building',
        text: 'Building',
        disabled: false
    },
    {
        value: 'Location',
        text: 'Location',
        disabled: false
    }
];

const defaultValue = {
    id:                 null,
    name:               null,
    root_path:          null,
    type:               null,
    property_type_id:   null,
    property_type_text:   null,
    location_type_id:   null,
    location_type_text:   null,
    lettable:           false,
    category_id:        null,
    category_text:        null,
    gfa:                null,
    nla:                null,
    owner:              null,
    mininum_rent:       null,
    minimum_rate_psf:   null,
    reference_rent:     null,
    reference_rate_psf: null,
    parent_id:          null,
    address:            null,
    is_active:          true,
    configured_as:      null,
    effective_date:     null
};

export default {
    name: 'property-form',
    components: {
        PropertyModalConfigField
    },
    props:{
        value: {
            type: Object,
            required: false,
            default: () => {}
        },
        isRoot: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            open:          false,
            loading:       false,
            nodeTypes:     cstNodeTypes,
            propertyTypes: [],
            locationTypes: [],
            categories:    [],
            property:      JSON.parse(JSON.stringify(defaultValue)),
            objTemp: {
                parent: null
            },
            address: {
                street_no: null,
                street_name: null,
                unit_no: null,
                building_name: null,
                country: 'Singapore',
                postal_code: null,
                geo_location : {
                latitude:null,
                longtitude:null,
              }
            },
            displayData: {
                full_address: '',
            },
            configuredAs:[
                'MT',
                'Hostel',
                'Bare'
            ],
            minDate: new Date(),
            modal: {
                open: false,
                property_id: null
            }
        }
    },
    watch: {
        value: function(val) {
            if(val && val.data) {
                this.property = Object.assign(JSON.parse(JSON.stringify(defaultValue)), val.data);
                if(val.parent && val.parent.data) {
                    this.objTemp.parent = val.parent.data;
                }
                this.setDisableNodeType(val);
            } else {
                this.property = JSON.parse(JSON.stringify(defaultValue));
            }

            if(this.property.effective_date){
                this.property.effective_date  = new Date(this.property.effective_date);
            }

            this.displayData.full_address = null;
            if(this.property.get_address && this.property.get_address.display_address) {
                this.address = Object.assign(this.address, this.property.get_address);
                if(!this.address.geo_location){
                    this.address.geo_location = {
                        latitude:null,
                        longitude:null
                    };
                }
                this.displayData.full_address = this.property.get_address.display_address;
            }
        },
        "objTemp.parent": function(val) {
            this.property.parent_id = null;
            if(val)
                this.property.parent_id = val.id;
        }
    },
    computed: {
        titleCard() {
            return this.property.root_path ? this.property.root_path : ' ';
        }
    },
    created(){
        if(this.value && this.value.data) {
            this.property = Object.assign(this.property, this.value.data);
        }

        this.getReferences("Property Type").then(result => {
            this.propertyTypes = result.items;
            this.$emit("loadReferences", {
                key: 'property_type_name',
                items: this.propertyTypes
            });
        });

        this.getReferences("Location Type").then(result => {
            this.locationTypes = result.items;
            this.$emit("loadReferences", {
                key: 'location_type_name',
                items: this.locationTypes
            });
        });

        this.getReferences("Property Category").then(result => {
            this.categories = result.items;
            this.$emit("loadReferences", {
                key: 'category_name',
                items: this.categories
            });
        })
    },
    methods:{
        editAddress() {
            if(this.property && this.property.get_address) {
                this.address = Object.assign(this.address, this.property.get_address);
                if(this.address.geo_location == null || !this.address.geo_location){
                  this.address.geo_location = {
                    latitude:null,
                    longtitude:null
                  }
                }
            } else {
                this.address = {
                    street_no: null,
                    street_name: null,
                    unit_no: null,
                    building_name: null,
                    country: 'Singapore',
                    postal_code: null,
                    geo_location: {
                      latitude:null,
                      longtitude:null
                    }
                };
            }
            this.open = true;
        },
        hanldeAddress() {
            this.displayData.full_address = generalAddressFormat(this.address);
            if(!this.property.get_address)
                this.property.get_address = {};
            this.property.get_address = Object.assign(this.property.get_address, this.address);
            this.property.get_address.geo_location.latitude = this.property.get_address.geo_location.latitude ? parseFloat(this.property.get_address.geo_location.latitude) : null;
            this.property.get_address.geo_location.longtitude = this.property.get_address.geo_location.longtitude ? parseFloat(this.property.get_address.geo_location.longtitude) : null;
            this.open = false;
        },
        async validationProperty() {
            return new Promise((resolve, reject) => {
                if (this.isRoot) return resolve(1);
                global.axios(`api/contracts/${this.$route.params.id}/properties/${this.property.parent_id}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(result => {
                    let parent = result.data.data;
                    if (this.property.type == 'Cluster' && (parent.type == 'Location' || parent.type == 'Building')) return resolve({ err: true, msg: "Node type is cluster. So the parent's node type must be cluster." })
                    if (this.property.type == 'Building' && (parent.type == 'Location' || parent.type == 'Building')) return resolve({ err: true, msg: "Node type is building. So the parent's node type must be cluster." })
                    if (this.property.type == 'Location' && parent.type == 'Cluster') return resolve({ err: true, msg: "Node type is location. So the parent's node type must be building or location." })
                    if (this.property.parent_id == this.property.id) return resolve({ err: true, msg: "Parent must be different from the current node." })
                    return resolve({ err: false, msg: "" })
                })
                .catch(error => {
                    return resolve({ err: true, msg: "An error occurred." })
                })
            })
        },
        save() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(async () => {
                if(this.loading) return;

                if (!this.property.parent_id && !this.isRoot) {
                    return this.$alertNotification("Parent is a required field", "danger");
                }

                if (!this.property.name) {
                    return this.$alertNotification("Name is a required field", "danger");
                }

                let validate = await this.validationProperty();
                if (validate.err) {
                    return this.$alertNotification(validate.msg, "danger");
                }

                this.loading = true;
                this.property.name = this.property.name.trim();
                if (this.property.owner) {
                    this.property.owner = this.property.owner.trim();
                }
                if (this.displayData.full_address) {
                    this.displayData.full_address = this.displayData.full_address.trim();
                }
                let params = Object.assign({}, {
                    id:                 this.property.id,
                    type:               this.property.type,
                    contract_id:        this.$route.params.id,
                    parent_id:          this.property.parent_id,
                    name:               this.property.name,
                    owner:              this.property.owner,
                    address:            this.displayData.full_address,
                    property_type_id:   this.property.property_type_id,
                    location_type_id:   this.property.location_type_id,
                    property_type_text:   this.property.property_type_text,
                    location_type_text:   this.property.location_type_text,
                    category_id:        this.property.category_id,
                    category_text:        this.property.category_text,
                    reference_rent:     this.property.reference_rent ? this.$accounting.unformat(this.property.reference_rent) : null,
                    reference_rate_psf: this.property.reference_rate_psf ? this.$accounting.unformat(this.property.reference_rate_psf) : null,
                    mininum_rent:       this.property.mininum_rent ? this.$accounting.unformat(this.property.mininum_rent) : null,
                    minimum_rate_psf:   this.property.minimum_rate_psf ? this.$accounting.unformat(this.property.minimum_rate_psf) : null,
                    gfa:                this.property.gfa ? this.$accounting.unformat(this.property.gfa) : null,
                    nla:                this.property.nla ? this.$accounting.unformat(this.property.nla) : null,
                    lettable:           this.property.lettable ? 1 : 0,
                    street_no:          this.address.street_no,
                    street_name:        this.address.street_name,
                    building_name:      this.address.building_name,
                    unit_no:            this.address.unit_no,
                    country:            this.address.country,
                    postal_code:        this.address.postal_code,
                    geo_location:        this.address.geo_location,
                    is_active:          this.property.is_active,
                    configured_as:      this.property.configured_as,
                    effective_date:     this.property.effective_date ? moment(this.property.effective_date).format("YYYY-MM-DD") : null,
                });

                let api = 'saveProperty';
                let keyMsg = 'adding';
                if(this.property.id) {
                    api = 'updateProperty';
                    keyMsg = 'editing';
                }

                this.$store.dispatch(`PropertyController/${api}`, params)
                .then(result => {
                    params.text    = params.name;
                    params.id      = result.data.data.id;
                    params.isBatch = false;
                    params.root_path = result.data.data.root_path
                    this.$emit('saveSuccess', params, keyMsg);
                    this.loading   = false;
                    this.$refs['parent-property'].loadRootProperty(true)
                    this.$alertNotification(this.$notificationV2(keyMsg, 'property'));
                }).catch(err => {
                    this.loading   = false;
                })
            }, 200);
        },
        /**/
        updateNodeTypes(arrTemp) {
            if(arrTemp.length) {
                for(let i = 0; i < arrTemp.length; i++) {
                    this.nodeTypes[i].disabled = arrTemp[i];
                }
            }
        },
        async setDisableNodeType(node) {
            if(!node.data || !node.data.parent_id)
                return;

            let parent = node.parent;
            if (!parent) {
                await global.axios(`api/contracts/${this.$route.params.id}/properties/${node.data.parent_id}`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                })
                .then(result => {
                    parent = this.property.parent = result.data.data;
                });
            }

            let parent_type = await parent.data.type;
            if(parent_type == 'Root') {
                return this.updateNodeTypes([false, false, false]);
            }

            if(parent_type == 'Cluster') {
                return this.updateNodeTypes([false, false, true]);
            }

            if(parent_type == 'Building' || parent_type == 'Location') {
                return this.updateNodeTypes([true, true, false]);
            }
        },
        getReferences(reference_type) {
            return new Promise((resolve, reject) => {
                this.$store.dispatch(`PropertyController/getReferences`, {
                    filter: { reference_type: reference_type },
                    limit: -1,
                    isCMS: true
                })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                })
            })
        },
        showConfiguredAs() {
            this.modal.property_id = this.property.id;
            this.modal.open = true;
        },
        refreshProperty(data) {
            this.$emit("refreshData")

        }
    }
}
</script>
